import { Star, StarFilled } from '@carbon/icons-react';
import type { ActionsOverlayAction } from 'component/actions-overlay';
import { type Comment, type CommentConfig, commentTable } from 'component/comment';
import type { Datastore } from 'util/datastore';
import type { Feature } from 'util/stdtypes';
import { declareGlobalProperty, t } from 'util/stdtypes';

export const pinnedCommentsProperty = declareGlobalProperty<Record<string, boolean | null>>('pinned_comments');

export const ActionPinComment: ActionsOverlayAction<{ commentKey: string }> = {
    label: t('Feature'),
    icon: Star,
    action: async ({ datastore, commentKey }) => {
        const pins = datastore.getGlobalProperty(pinnedCommentsProperty) ?? {};
        const newPins = { ...pins, [commentKey]: true };
        datastore.setGlobalProperty(pinnedCommentsProperty, newPins);
        await datastore.callServerAsync('derivedviews', 'runTriggers', {
            type: 'comment',
            key: commentKey,
        });
    },
};

export const ActionUnpinComment: ActionsOverlayAction<{ commentKey: string }> = {
    label: t('Featured'),
    icon: StarFilled,
    action: async ({ datastore, commentKey }) => {
        const pins = datastore.getGlobalProperty(pinnedCommentsProperty) ?? {};
        const newPins = { ...pins, [commentKey]: null };
        datastore.setGlobalProperty(pinnedCommentsProperty, newPins);
        await datastore.callServerAsync('derivedviews', 'runTriggers', {
            type: 'comment',
            key: commentKey,
        });
    },
};

export function getPinCommentActions(datastore: Datastore, commentKey: string) {
    const pins = datastore.getGlobalProperty(pinnedCommentsProperty) ?? {};
    const comment = datastore.getObject<Comment>(commentTable, commentKey);
    if (!comment || comment.replyTo) {
        return [];
    }

    const isPinned = pins?.[commentKey];
    return isPinned ? [ActionUnpinComment] : [ActionPinComment];
}

export const PinCommentFeature: Feature<CommentConfig, {}> = {
    name: 'Pin Comment in Teaser',
    key: 'pin_comment',
    providesConfig: {
        commentAdminActions: [getPinCommentActions],
    },
};
